import { type FC } from 'react';
import { isEqual } from 'lodash-es';

import { type Conflict } from '@editor2/types/conflict';
import { sanitizeAttributeName } from '@editor2/components/CourseChangesDiff/helpers';
import { REORDER_ALLOW_LIST } from '@editor2/types/reorderAllowList';
import IncomingChangesDivider from '../common/IncomingChangesDivider';
import ConflictDiffView from '../common/ConflictDiffView';
import DeletedEntityView from '../common/DeletedEntity';
import { createReorderConflict, getValue } from '../helpers';
import InitialCurrentReorderView from './InitialCurrentReorder';

interface Props {
	conflict: Conflict;
	courseId: number;
	deletedEntityName: string;
	showButton: boolean;
}

const ModifiedDeletedView: FC<Props> = (props) => {
	const { conflict, courseId, deletedEntityName, showButton } = props;

	return (
		<div>
			{Object.keys(conflict.current).map((attribute, index) => {
				if (isEqual(conflict.initial[attribute], conflict.current[attribute])) return;

				return (
					<div key={index}>
						<div>{sanitizeAttributeName(attribute)}</div>

						{!REORDER_ALLOW_LIST.includes(attribute) && (
							<ConflictDiffView
								oldValue={getValue(conflict.initial, attribute)}
								newValue={getValue(conflict.current, attribute)}
							/>
						)}

						{REORDER_ALLOW_LIST.includes(attribute) && (
							<InitialCurrentReorderView
								conflict={createReorderConflict(conflict, attribute)}
								courseId={courseId}
							/>
						)}
					</div>
				);
			})}

			<IncomingChangesDivider courseId={courseId} conflict={conflict} showButton={showButton} />

			<DeletedEntityView name={deletedEntityName} />
		</div>
	);
};

export default ModifiedDeletedView;
